import styled from "@emotion/styled"
import type { PHeadingProps } from "@porsche-design-system/components-react"
import {
	leadingNormal,
	typescale2Xl,
	typescaleLg,
	typescaleMd,
	typescaleSm,
	typescaleXl,
} from "@porsche-design-system/components-react/emotion"
import { SkeletonComponent } from "./SkeletonComponent"

const mapSizeToTypeScale: Record<Extract<PHeadingProps["size"], "sm" | "md" | "lg" | "xl" | "2xl">, string> = {
	"2xl": typescale2Xl,
	lg: typescaleLg,
	md: typescaleMd,
	sm: typescaleSm,
	xl: typescaleXl,
}

export const SkeletonHeading = styled(SkeletonComponent)<{
	$width?: string
	size?: keyof typeof mapSizeToTypeScale
}>`
	height: ${leadingNormal};
	font-size: ${({ size = "2xl" }) => (size ? mapSizeToTypeScale[size] : undefined)};
	${({ $width }) => `width: ${$width ?? "50%"};`};
`
